'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VueRouteMiddleware = function () {

    /**
     * Set instance properties and call defined 
     * middlewares on matching routes
     * 
     * @param {object} definedMiddlewares 
     * @param {object} to 
     * @param {object} from 
     * @param {function|undefined} next
     * 
     * @var {object} middlewares // predefined middlewares
     * @var {boolean} nextHasCalled // if next was called in the middlewares
     * @var {array} toMiddleware // arguments passed to middleware function
     */
    function VueRouteMiddleware(definedMiddlewares, to, from, next) {
        var _this = this;

        _classCallCheck(this, VueRouteMiddleware);

        if (this._isObject(definedMiddlewares)) {
            this.middlewares = definedMiddlewares;
        } else {
            this._error('Defined middlewares must be of type Object!');
            this.middlewares = {};
        }
        this.to = to;
        this.from = from;
        this.next = next;
        this.nextHasCalled = false;
        if (this.to && this.to.matched) {
            // Apply middleware if anu route matched
            to.matched.every(function (route) {
                return _this.applyRouteMiddlewares(route);
            });
        }
        if (this.next && !this.nextHasCalled) {
            // call next if user didnt call it
            this.callNext();
        }
    }

    /**
     * Function used to pass arguments to middlewares with spred syntax
     * 
     * @return {array}
     */


    _createClass(VueRouteMiddleware, [{
        key: 'toMiddleware',
        value: function toMiddleware() {
            return [this.to, this.from, this._isFunction(this.next) ? this.callNext.bind(this) : undefined];
        }

        /**
         * Function that is passed to middleware as a next function wrapper
         * toggling `nextHasCalled` trigger
         * 
         * @param  {...any} args
         */

    }, {
        key: 'callNext',
        value: function callNext() {
            if (!this.nextHasCalled) this.nextHasCalled = true;
            return this.next.apply(this, arguments);
        }
    }, {
        key: 'applyRouteMiddlewares',


        /**
         * Fuction applying middlewares of a single route and deciding
         * if other matched routes should be checked as well
         * 
         * @param {*} route 
         * 
         * @return {boolean}
         */
        value: function applyRouteMiddlewares(route) {
            var _this2 = this;

            if (route.meta && route.meta.middleware) {
                var middlewareKeys = route.meta.middleware;
                if (this._isArray(middlewareKeys)) {
                    return middlewareKeys.every(function (middleware) {
                        return _this2.applyMiddleware(middleware);
                    });
                } else {
                    return this.applyMiddleware(middlewareKeys);
                }
            }
            return true;
        }

        /**
         * Function calling middlewares and deciding if middleware chain
         * must be continued or stopped after first faliure
         * 
         * @param {string|function} middleware 
         * 
         * @return {boolean}
         */

    }, {
        key: 'applyMiddleware',
        value: function applyMiddleware(middleware) {
            var result = this.getMiddleware(middleware).apply(undefined, _toConsumableArray(this.toMiddleware()));
            return result === undefined ? true : result;
        }

        /**
         * Function to get middleware function.
         * In case of function validation failure
         * console the error and return empty function
         * 
         * @param {string|function} middleware 
         * 
         * @return {function}
         */

    }, {
        key: 'getMiddleware',
        value: function getMiddleware(middleware) {
            if (this._isString(middleware)) {
                if (this.middlewares.hasOwnProperty(middleware)) {
                    if (this._isFunction(this.middlewares[middleware])) {
                        return this.middlewares[middleware];
                    } else {
                        this._error(middleware + ' is not a function!');
                    }
                }
            } else if (this._isFunction(middleware)) {
                return middleware;
            } else {
                this._error('All middlewares must be functions!');
            }
            return function () {
                return true;
            };
        }

        /**
         * @param {string} text 
         * 
         * @return {boolean}
         */

    }, {
        key: '_error',
        value: function _error(text) {
            console.error(this.constructor.name + ': ' + text);
        }

        /**
         * @param {*} toCheck 
         * 
         * @return {boolean}
         */

    }, {
        key: '_isString',
        value: function _isString(toCheck) {
            return typeof toCheck === "string" || toCheck instanceof String;
        }

        /**
         * @param {*} toCheck 
         * 
         * @return {boolean}
         */

    }, {
        key: '_isArray',
        value: function _isArray(toCheck) {
            return Array.isArray(toCheck);
        }

        /**
         * @param {*} toCheck 
         * 
         * @return {boolean}
         */

    }, {
        key: '_isFunction',
        value: function _isFunction(toCheck) {
            return typeof toCheck === "function";
        }

        /**
         * @param {*} toCheck 
         * 
         * @return {boolean}
         */

    }, {
        key: '_isObject',
        value: function _isObject(toCheck) {
            return (typeof toCheck === 'undefined' ? 'undefined' : _typeof(toCheck)) === "object" && toCheck !== null;
        }
    }]);

    return VueRouteMiddleware;
}();

;

exports.default = function () {
    var definedGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function () {
        for (var _len = arguments.length, toMiddleware = Array(_len), _key = 0; _key < _len; _key++) {
            toMiddleware[_key] = arguments[_key];
        }

        return new (Function.prototype.bind.apply(VueRouteMiddleware, [null].concat([definedGroups], toMiddleware)))();
    };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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